import resourceList from '../resource_list';
import rest from '../rest';

async function loadCustomerNotificationStatus() {
  return rest.postAcl(resourceList.CENTER, '/notification/load-notification-status');
}

export default loadCustomerNotificationStatus;
